import { render, staticRenderFns } from "./wine-investors-registration.vue?vue&type=template&id=068b7a7e&scoped=true"
import script from "./wine-investors-registration.vue?vue&type=script&lang=js"
export * from "./wine-investors-registration.vue?vue&type=script&lang=js"
import style0 from "./wine-investors-registration.vue?vue&type=style&index=0&id=068b7a7e&prod&scoped=true&lang=css"
import style1 from "./wine-investors-registration.vue?vue&type=style&index=1&id=068b7a7e&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068b7a7e",
  null
  
)

export default component.exports